// removed by extract-text-webpack-plugin
module.exports = {"controls":"controls__controls"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/controls.scss
// module id = 1226
// module chunks = 0